import { observable, action, makeObservable } from 'mobx';

export class OverBudgetStore {
    @observable warnOverBudget: boolean = false;

    @observable overBudgetNames: string;

    constructor() {
        makeObservable(this);
    }

    @action
    turnOnOverBudgetWarning(overBudgets: ICountryBudget[]): void {
        this.overBudgetNames = overBudgets.map(overBudget => overBudget.name).join(', ');
        this.warnOverBudget = true;
    }

    @action
    turnOffOverBudgetWarning(): void {
        this.warnOverBudget = false;
    }
}